import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGE_SIZE } from "../../constants";
import { Badge } from "../../components/adminUi";
import { useGetSupportTicketsQuery } from "./supportTicketApiSlice";
import {
  CenteredLoader,
  EmptyCard,
  ErrorNote,
  ListPagination,
  Page,
  PageBody,
  PageHeader,
  TicketList,
  useIsNarrow,
} from "./supportTicketChrome";

/** 지원 요청 관리 — every trainee's tickets, so unlike 내 피드백 it shows 작성자 and an
 *  unanswered count. Chrome shared with the other three ticket pages. */
const AdminSupportTicketsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const page_size = queryParams.get("page_size") || PAGE_SIZE;
  const isNarrow = useIsNarrow();

  const { data, isLoading, isError } = useGetSupportTicketsQuery({ page, page_size });

  const handlePaginationChange = (event, { activePage }) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("page", activePage);
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  const tickets = data?.results || [];
  const totalPages = data?.count ? Math.ceil(data.count / page_size) : 1;
  const openCount = tickets.filter((t) => t.status === "open").length;

  return (
    <Page>
      <PageHeader
        icon="life ring"
        title="지원 요청 관리"
        subtitle="사용자가 제출한 피드백 확인 및 답변"
        right={
          // With three statuses and one reader, how many are unanswered is the only thing
          // worth surfacing at a glance — cheaper than a filter nobody asked for.
          !isLoading && !isError && tickets.length > 0 ? (
            <Badge tone={openCount ? "amber" : "green"}>
              {openCount ? `미답변 ${openCount}건` : "미답변 없음"}
            </Badge>
          ) : null
        }
      />
      <PageBody>
        {isLoading && <CenteredLoader />}
        {isError && <ErrorNote>요청 목록을 불러오지 못했습니다.</ErrorNote>}

        {!isLoading && !isError && tickets.length === 0 && (
          <EmptyCard>제출된 피드백이 없습니다.</EmptyCard>
        )}

        {!isLoading && !isError && tickets.length > 0 && (
          <>
            <TicketList
              tickets={tickets}
              showAuthor
              onOpen={(ticket) => navigate(`/admin/support-tickets/${ticket.id}`)}
              isNarrow={isNarrow}
            />
            <ListPagination
              page={page}
              totalPages={totalPages}
              onChange={handlePaginationChange}
            />
          </>
        )}
      </PageBody>
    </Page>
  );
};

export default AdminSupportTicketsPage;
